module.exports = __webpack_public_path__ + "static/media/delivery.6c9ee3a4.png";